import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle} </title>
                    <meta name="description" content="Stránka na propagaci developerského projektu Liebiegovy Výhledy." />
                    <meta name="google-site-verification" content="LD-L01cZEq8c37Rk1CtpPXHcU-J2P7xonliNA9sc9Mg" />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
